import { Box } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Autorenew';
import { keyframes } from '@mui/system';
import { useState } from 'react';
import { useAppDispatch } from '../../../common/hooks';
import { refreshOktaStatus } from '../../../features/adviceAdmin';
import { InlinePill } from './InlinePill';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const OktaStatusCell = ({ row }: any) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(row.original.okta_login_status);

    const handleRefresh = async () => {
        setLoading(true);
        try {
            const res: any = await dispatch(
                refreshOktaStatus({ userId: row.original.id, fromTenant: row.original.userTenant })
            );
            if (res?.payload) {
                if (Array.isArray(res.payload)) {
                    const updatedUser = res.payload.find((u: any) => u.id === row.original.id);
                    setStatus(updatedUser?.okta_login_status ?? '');
                } else if (res.payload.success === false) {
                    setStatus('');
                }
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, transform: 'translateY(-5px)', justifyContent: 'center' }}>
            <Box
                onClick={loading ? undefined : handleRefresh}
                sx={{
                    width: 24,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    backgroundColor: '#F0F0F0',
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#E5E5E5' }
                }}
            >
                <RefreshIcon
                    sx={{
                        fontSize: 16,
                        color: '#323131ff',
                        animation: loading ? `${spin} 1s linear infinite` : 'none',
                        transition: 'color 0.2s ease',
                        '&:hover': { color: '#111111' }
                    }}
                />
            </Box>
            <InlinePill status={status} />
        </Box>
    );
};
